import './PendingChangesPanel.scss';
import { ReactNode } from 'react';
import { MdArrowDownward } from 'react-icons/md';
import { Header } from '../StickyTable';
import { displayValue, renderValue, RowType } from './pending-changes-utils';

interface PendingEditedRowProps<R> {
  columns: Header[];
  newRow: R;
  oldRow: R;
  hideUnchanged?: boolean;
  pendingRowHeaderRender?: (row: R) => ReactNode;
}

export const PendingEditedRow = <R extends RowType>({
  columns,
  newRow,
  oldRow,
  hideUnchanged = false,
  pendingRowHeaderRender
}: PendingEditedRowProps<R>) => (
  <div className='pending-changes-row-container pending-edit-row-container'>
    {pendingRowHeaderRender && (
      <div className='pending-changes-row-title'>{pendingRowHeaderRender(oldRow)}</div>
    )}
    {columns.map(col => {
      const { label, field, renderer, diffRenderer } = col;
      const oldVal = displayValue(oldRow[field ?? '']);
      const newVal = displayValue(newRow[field ?? '']);

      if (hideUnchanged && oldVal === newVal) return null;

      const valueContent = (() => {
        if (oldVal === newVal)
          return <div>{renderer ? renderValue(renderer(newRow)) : newVal}</div>;
        if (diffRenderer)
          return <div className='pending-changes-row-val'>{diffRenderer({ oldRow, newRow })}</div>;
        return (
          <div className='pending-changes-row-val'>
            <div className='old-val'>{renderer ? renderValue(renderer(oldRow)) : oldVal}</div>
            <div className='pending-changes-arrow'>
              <MdArrowDownward />
            </div>
            <div className='new-val'>{renderer ? renderValue(renderer(newRow)) : newVal}</div>
          </div>
        );
      })();

      return (
        <div key={label}>
          <div className='pending-changes-row'>
            {label && <b className='pending-changes-row-label'>{label}:</b>}
            {valueContent}
          </div>
        </div>
      );
    })}
  </div>
);
